import React from 'react'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import LabelInput from '../../../form/component/LabelInput'
import { MODE_MONTHLY, MODE_WEEKLY } from '../../state/funnel-builder/const'
import { COMPANY_CODE_SELECT_VALUE_LIST } from '../../../internationalization/const'

const monthList = []
for (let month = 1; month < 13; month++) {
    monthList.push({
        id: '' + month,
        value: '' + month,
    })
}

const weekList = []
for (let week = 1; week < 54; week++) {
    weekList.push({
        id: '' + week,
        value: '' + week,
    })
}


const yearList = []
const today = new Date()
for (let year = 2018; year <= today.getFullYear(); year++) {
    yearList.push({
        id: '' + year,
        value: '' + year,
    })
}


const FunnelStartSelector = ({ funnelStartTime, changeFunnelStartTime, mode, changeModeMonthly, changeModeWeekly }) => {
    return (<ContentBox title="Process Funnel Builder">
        <Row>
            <Column>Select Cohort</Column>
        </Row>
        {mode === MODE_MONTHLY && (
            <Row>
                <Column size={2}>
                    <LabelInput label="Month">
                        <Select object={funnelStartTime} name="month" valueList={monthList}
                            onChange={changeFunnelStartTime}/>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Year">
                        <Select object={funnelStartTime} name="year" valueList={yearList}
                            onChange={changeFunnelStartTime}/>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Company">
                        <Select object={funnelStartTime} name="companyCode" valueList={COMPANY_CODE_SELECT_VALUE_LIST}
                            onChange={changeFunnelStartTime}/>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Change Mode">
                        <br/><button className="btn btn-primary" onClick={changeModeWeekly}>weekly</button>
                    </LabelInput>
                </Column>
                <Column size={4}/>
            </Row>
        )}
        {mode === MODE_WEEKLY && (
            <Row>
                <Column size={2}>
                    <LabelInput label="Week">
                        <Select object={funnelStartTime} name="week" valueList={weekList}
                            onChange={changeFunnelStartTime}/>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Year">
                        <Select object={funnelStartTime} name="year" valueList={yearList}
                            onChange={changeFunnelStartTime}/>
                    </LabelInput>
                </Column>
                <Column size={2}>
                    <LabelInput label="Change Mode">
                        <br/><button className="btn btn-primary" onClick={changeModeMonthly}>monthly</button>
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>
        )}

    </ContentBox>)
}

export default FunnelStartSelector



// WEBPACK FOOTER //
// ./src/modules/analytics/component/funnel-builder/FunnelStartSelector.js